import { render, staticRenderFns } from "./ConfirmSummaryTemperature.vue?vue&type=template&id=f22b8760&scoped=true&"
import script from "./ConfirmSummaryTemperature.vue?vue&type=script&lang=js&"
export * from "./ConfirmSummaryTemperature.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmSummaryTemperature.vue?vue&type=style&index=0&id=f22b8760&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22b8760",
  null
  
)

export default component.exports